/* SK Product Tabs - logica de pestanas */
(function () {
  'use strict';

  function initSection(container) {
    /* R45: guard contra doble inicializacion */
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    /* R46: buscar dentro del container */
    var tabs = container.querySelectorAll('.sk-product-tabs__tab');
    var panels = container.querySelectorAll('.sk-product-tabs__panel');

    if (tabs.length === 0 || panels.length === 0) return;

    /* Activar un tab por su data-sk-tab */
    function activateTab(targetTab) {
      /* Desactivar todos los tabs */
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('sk-product-tabs__tab--active');
        tabs[i].setAttribute('aria-selected', 'false');
        tabs[i].setAttribute('tabindex', '-1');
      }

      /* Ocultar todos los paneles */
      for (var j = 0; j < panels.length; j++) {
        panels[j].setAttribute('hidden', '');
      }

      /* Activar el tab seleccionado */
      targetTab.classList.add('sk-product-tabs__tab--active');
      targetTab.setAttribute('aria-selected', 'true');
      targetTab.setAttribute('tabindex', '0');

      /* Mostrar el panel correspondiente */
      var panelId = targetTab.getAttribute('aria-controls');
      var panel = container.querySelector('#' + panelId);
      if (panel) {
        panel.removeAttribute('hidden');
      }
    }

    /* Inicializar tabindex en todos los tabs */
    for (var k = 0; k < tabs.length; k++) {
      if (tabs[k].getAttribute('aria-selected') === 'true') {
        tabs[k].setAttribute('tabindex', '0');
      } else {
        tabs[k].setAttribute('tabindex', '-1');
      }
    }

    /* R47: listener al container, delegacion de eventos */
    container.addEventListener('click', function (e) {
      var tab = e.target.closest('.sk-product-tabs__tab');
      if (!tab) return;
      activateTab(tab);
    });

    /* Navegacion con teclado: ArrowLeft, ArrowRight, Home, End */
    var tablist = container.querySelector('.sk-product-tabs__nav');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var currentTab = e.target.closest('.sk-product-tabs__tab');
        if (!currentTab) return;

        /* Encontrar indice del tab actual */
        var tabArray = Array.prototype.slice.call(tabs);
        var currentIndex = tabArray.indexOf(currentTab);
        var newIndex = -1;

        if (e.key === 'ArrowRight') {
          newIndex = (currentIndex + 1) % tabArray.length;
          e.preventDefault();
        } else if (e.key === 'ArrowLeft') {
          newIndex = (currentIndex - 1 + tabArray.length) % tabArray.length;
          e.preventDefault();
        } else if (e.key === 'Home') {
          newIndex = 0;
          e.preventDefault();
        } else if (e.key === 'End') {
          newIndex = tabArray.length - 1;
          e.preventDefault();
        }

        if (newIndex >= 0) {
          activateTab(tabArray[newIndex]);
          tabArray[newIndex].focus();
        }
      });
    }
  }

  /* R44: querySelectorAll para TODAS las instancias */
  var sections = document.querySelectorAll('.sk-product-tabs');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sk-product-tabs');
    if (section) initSection(section);
  });
})();
